/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Help_Search_NoneInputs */

const en_help_search_none = /** @type {(inputs: Help_Search_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nothing matches “${i?.query}” yet.`)
};

const pl_help_search_none = /** @type {(inputs: Help_Search_NoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nic jeszcze nie pasuje do „${i?.query}”.`)
};

/**
* | output |
* | --- |
* | "Nothing matches “{query}” yet." |
*
* @param {Help_Search_NoneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_search_none = /** @type {((inputs: Help_Search_NoneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Search_NoneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_search_none(inputs)
	return en_help_search_none(inputs)
});